<div class="titan-menu-popover" *ngIf="isOpen">
  <ng-content></ng-content>
</div>
